import { backendApi } from "@/services/api";
import { Filter } from "@/shared/lib/filter/filter";
import type { Address } from "./address";

const addressApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    addressList: build.query<List, ListRequest>({
      query: (request) => ({
        url: `/companies/addresses`,
        method: "GET",
        params: {
          request: btoa(JSON.stringify(request)),
        },
      }),
      providesTags: (result) =>
        result?.items
          ? [
              ...result.items.map(({ id }) => ({
                type: "Address" as const,
                id,
              })),
              { type: "Address", id: "LIST" },
            ]
          : [{ type: "Address", id: "LIST" }],
    }),
    getAddress: build.query<Address, GetRequest>({
      query: (request) => ({
        url: `/companies/addresses/${request.id}`,
        method: "GET",
      }),
      providesTags: (_result, _e, request) => [
        { type: "Address", id: request.id },
      ],
    }),
    putAddress: build.mutation<Address, PutRequest>({
      query: (request) => ({
        url: `/companies/addresses`,
        method: "PUT",
        body: request,
      }),
      invalidatesTags: ["Address"],
    }),
    deleteAddress: build.mutation<DeleteResponse, DeleteRequest>({
      query: (request) => ({
        url: `/companies/addresses`,
        method: "DELETE",
        body: request,
      }),
      invalidatesTags: ["Address"],
    }),
  }),
});

export const {
  useAddressListQuery,
  useGetAddressQuery,
  usePutAddressMutation,
  useDeleteAddressMutation,
} = addressApi;

export interface PutRequest {
  id: string;
  companyId: string;
  street: string;
  houseNumber: string;
  postbox: string;
  postalCode: string;
  city: string;
  country: string;
  isPrimaryAddress: boolean;
  isInvoicingAddress: boolean;
}

export interface GetRequest {
  id: string;
}

export interface ListRequest {
  companyId?: Filter<string>;
  limit?: number;
  offset?: number;
}

export interface List {
  count: number;
  items: Address[];
}

export interface DeleteRequest {
  id: string;
}

export interface DeleteResponse {}
